import {
  DASHBOARDKEYSEARCH,
  SET_FINANCIAL_YEAR,
} from "../../actions-Types/actionTypes";

interface DashboardAction {
  type: typeof DASHBOARDKEYSEARCH;
  payload: string;
}

interface FinancialYearAction {
  type: typeof SET_FINANCIAL_YEAR;
  payload: { startDate: string; endDate: string };
}

const initialState = {
  dashboardSearch: "",
  financialYear: {
    startDate: "",
    endDate: "",
  },
};

export default function dashboardReducer(
  state = initialState,
  action: DashboardAction | FinancialYearAction
) {
  switch (action.type) {
    case DASHBOARDKEYSEARCH:
      return { ...state, dashboardSearch: action.payload };
    case SET_FINANCIAL_YEAR:
      return {
        ...state,
        financialYear: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate,
        },
      };
    default:
      return state;
  }
}
